import { ReactComponent as NextIcon } from 'assets/icons/roll-next.svg'
import { ReactComponent as PrevIcon } from 'assets/icons/roll-prev.svg'

import { Button, makeStyles } from '@material-ui/core'

import { SpacedGroup } from 'UI/Components'

import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
    button: {
        background: 'rgba(0, 0, 0, 0.4)',
        color: '#fff',
        '&:hover': {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    },
    hoverControls: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 3.5),
        width: '100%',
        position: 'absolute',
        top: 20,
        '& > *': {
            opacity: 0,
            transform: 'translateY(-30px)',
            transition: 'opacity 0.1s linear, transform 0.1s linear'
        }
    },
    visible: {
        '&, & > *': {
            opacity: 1,
            zIndex: 1,
            transform: 'translateY(0)'
        }
    }
}))

type Props = {
    onClickPrev: () => void
    onClickNext: () => void
    disableNext?: boolean
    disablePrev?: boolean
    isVisible: boolean
}

export const PlayerButtons = ({
    onClickPrev,
    onClickNext,
    disableNext = false,
    disablePrev = false,
    isVisible
}: Props) => {
    const classes = useStyles()

    return (
        <SpacedGroup
            spacing={3}
            className={clsx(classes.hoverControls, isVisible && classes.visible)}
        >
            <Button
                classes={{ root: classes.button }}
                size="small"
                color="default"
                disabled={disablePrev}
                onClick={onClickPrev}
                startIcon={<PrevIcon />}
            >
                Prev Video
            </Button>

            <Button
                classes={{ root: classes.button }}
                size="small"
                color="default"
                disabled={disableNext}
                onClick={onClickNext}
                startIcon={<NextIcon />}
            >
                Next Video
            </Button>
        </SpacedGroup>
    )
}
